import paginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	informacoesOcorrencia: {
		idEntidade: null,
		tipoEntidade: null,
	},
	informacoesItens: {
		itens: [],
		totalItens: null,
		totalPaginas: null,
	},
	atualizaListagem: 0,
	paginacao: paginacaoListagem(['id']),
}
